import { z } from 'zod';
import { BaseEventSchema } from './Base';

export const AddressNotInDeliveryZoneSchema = BaseEventSchema.extend({
  street: z.string(),
  commune: z.string().nullable(),
});

export enum ErrorEventTypes {
  AddressNotInDeliveryZone = 'error.address.not_in_delivery_zone',
}

export const ErrorEventTrackingSchemas = {
  [ErrorEventTypes.AddressNotInDeliveryZone]: AddressNotInDeliveryZoneSchema,
} as const;
